<template>
  <div>
    <Navbar class="is-sticky"/>
    <div class="background-image-container">
      <div class="background-text mt-5">Use AI to tap into the wisdom of past explorers</div>
    </div>
    <div v-if="blogPostsLoaded" class="blog-posts-section">
      <span class="news-label mt-2">News</span>
      <div class="blog-cards">
        <div v-for="(post, index) in blogPosts" :key="post.slug" :class="['blog-card', { 'last-in-row': (index + 1) % 3 === 0 }]" @click="openBlogPost(post.slug)">
          <img :src="post.feature_image" :alt="post.title" class="blog-card-image" />
          <div class="mt-3">
            <span class="author-name">{{post.authors[0].name}}</span><br>
            <p class="date-label">{{formatDate(post.published_at)}}</p>
            <div class="blog-card-title">{{ post.title }}</div>
            <span class="excerpt">{{post.excerpt}}</span>
          </div>
        </div>
      </div>
    </div>
    <FooterMain v-if="blogPostsLoaded" FooterStyle="bg_drak-footer"/>
  </div>
</template>

<script>
import axios from 'axios';
import Navbar from '../components/Navbar';
import FooterMain from '@/components/FooterMain';

export default {
  name: 'Blog',
  components: {
    Navbar,
    FooterMain
  },
  data() {
    return {
      blogPosts: [],
      blogPostsLoaded: false
    };
  },
  created() {
    this.fetchBlogPosts();
  },
  methods: {
    async fetchBlogPosts() {
      try {
        const response = await axios.get('https://blog.radixplore.com/ghost/api/v3/content/posts/?key=c2c8375e38398e6e611f9c5c8f', {
          params: {
            include: 'tags,authors'
          }
        });
        this.blogPosts = response.data.posts;
        this.blogPostsLoaded = true;
      } catch (error) {
        console.error('Error fetching blog posts:', error);
      }
    },
    openBlogPost(slug) {
      this.$router.push({ name: 'BlogPost', params: { slug } });
    },
    formatDate(dateString) {
      const options = { month: 'short', day: '2-digit', year: 'numeric' };
      const formattedDate = new Date(dateString).toLocaleDateString('en-US', options);
      return formattedDate;
    }
  },
};
</script>

<style>
.background-image-container {
  background-image: url('https://images.unsplash.com/photo-1620641788421-7a1c342ea42e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3wxMTc3M3wwfDF8c2VhcmNofDV8fGdyYWRpZW50fGVufDB8fHx8MTcwNjg3MTMwNXww&ixlib=rb-4.0.3&q=80&w=2000');
  background-size: cover;
  background-position: center;
  text-align: center;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.background-text {
  font-size: 36px;
  color: white;
}

.blog-posts-section {
  background: #ffffff;
}

.blog-cards {
  width: 60%;
  margin: 0 auto;
  padding: 3rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.blog-card {
  width: calc(33.333% - 20px);
  margin-bottom: 50px;
  cursor: pointer;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  padding: 10px;
}

.blog-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.blog-card:last-child {
  margin-right: 0; 
}

.blog-card-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.blog-card-title {
  font-size: 18px;
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
}

.last-in-row {
  margin-right: 0;
}

.excerpt {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-family: 'Poppins', sans-serif;
  font-weight: 300;
}

.author-name {
  font-size: smaller;
  font-family: 'Raleway', sans-serif;
  font-weight: 300;
  text-transform: uppercase;
}

.date-label {
  font-size: smaller;
  font-family: 'Raleway', sans-serif;
  font-weight: 100;
  text-transform: uppercase;
  margin-bottom: 0.5rem;
}

.news-label {
  left: 24%;
  position: absolute;
}
</style>
